module.exports = __webpack_public_path__ + "img/bgsizemobile.e0aaa9e4.jpg";